import React, { useEffect, useCallback } from "react";
import { WidgetProps } from "@rjsf/utils";
import { getValueIgnoreCase } from "../../../../utils/objectUtils";

const HnnNiveauWidget = (props: WidgetProps) => {
  const {
    onChange,
    schema,
    options,
  } = props;
  // Get project type from options (passed from createUI)
  const projectType = options?.projectType;
  
  // Helper function to find project type data regardless of key capitalization
  const findProjectTypeData = useCallback(() => {
    if (!schema.backgroundData || !projectType) {
      return null;
    }
    
    // Use utility function for case-insensitive lookup
    const projectTypeData = getValueIgnoreCase(schema.backgroundData, 'projecttype');
    
    return projectTypeData && typeof projectTypeData === 'object' && projectTypeData !== null 
      ? projectTypeData as Record<string, unknown>
      : null;
  }, [schema.backgroundData, projectType]);
  
  // Get the appropriate value from backgroundData.ProjectType based on project type
  const getProjectTypeValue = useCallback(() => {
    const projectTypeData = findProjectTypeData();
    
    if (!projectTypeData || !projectType || typeof projectType !== 'string') {
      return schema.default || "";
    }
    
    const projectValue = getValueIgnoreCase(projectTypeData, projectType);
    
    // Return the value if found, otherwise return the schema default as fallback
    return projectValue !== undefined ? String(projectValue) : (schema.default || "");
  }, [findProjectTypeData, projectType, schema.default]);

  // Always set the value based on project type, overriding any existing default
  useEffect(() => {
    const dynamicValue = getProjectTypeValue();
    onChange(dynamicValue);
  }, [projectType, schema.backgroundData, schema.default, onChange, getProjectTypeValue]);

  const displayValue = getProjectTypeValue();

  return (
    <span className="text-xs text-primary-800 flex flex-row justify-start text-base">
      {displayValue}
    </span>
  );
};

export default HnnNiveauWidget;